import { useSummaryMetrics } from "reports/utils/metricUtils";
import { MetricEnum, MetricUnitsEnum } from "reports/utils/metricTypes";
import { getPciukMetrics } from "./pciukEosUtils";
import { PnlBreakdown } from "../../../../getters/pnlBreakdownGetter/pnlBreakdownTypes";
import SummaryMetrics from "../../../../components/Reports/SummaryMetrics";
import { unplanned, darkYellow } from "../../../../constants/colors";
import { useReportConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

export default function PciukSummaryMetrics({
  data,
  processGroupName,
}: {
  data: PnlBreakdown;
  processGroupName?: string;
}) {
  const reportConfig = useReportConfig();
  const { engineeringDowntime, operationDowntime, valueAddedOpportunity } =
    getPciukMetrics(data);
  const configMetricsRow1 =
    reportConfig?.eosReportMetricsConfig?.summaryMetricsRow1?.map(metric => ({
      ...metric,
      ...(metric.title === "Eng. Downtime"
        ? { customValue: engineeringDowntime, color: unplanned }
        : metric.title === "Operation Downtime"
          ? { customValue: operationDowntime, color: darkYellow }
          : metric.title === "Value Added Opportunity"
            ? { customValue: valueAddedOpportunity, color: darkYellow }
            : {}),
    }));
  const summaryMetricsRow1 = useSummaryMetrics({
    metrics: configMetricsRow1 ?? [
      {
        name: MetricEnum.OEE,
        title: "Line Efficiency",
      },
      { name: MetricEnum.AVAIL },
      { name: MetricEnum.PERF },
      { name: MetricEnum.TAGGING },
      {
        title: "Eng. Downtime",
        customValue: engineeringDowntime,
        unit: MetricUnitsEnum.percent,
        color: unplanned,
      },
      {
        title: "Operation Downtime",
        customValue: operationDowntime,
        unit: MetricUnitsEnum.percent,
        color: darkYellow,
      },
      {
        title: "Value Added Opportunity",
        customValue: valueAddedOpportunity,
        unit: MetricUnitsEnum.percent,
        color: darkYellow,
      },
    ],
    pnlBreakdown: data,
  });

  const summaryMetricsRow2 = useSummaryMetrics({
    metrics: reportConfig?.eosReportMetricsConfig?.summaryMetricsRow2 ?? [
      { name: MetricEnum.OPERATION_TIME, title: "Production Time" },
      { name: MetricEnum.PRODUCING_TIME },
    ],
    pnlBreakdown: data,
  });

  return (
    <SummaryMetrics
      processGroupName={processGroupName}
      summaryMetrics={[summaryMetricsRow1, summaryMetricsRow2]}
    />
  );
}
